<template>
	<!-- 
    This error modal is only displayed if we're trying to do a booking based of an "orderref" query parameter, and that booking fails.
    In that case, we're displaying an error in the modal since we're not displaying the Patientform where error messages are normally displayed.
    -->
	<div
		class="full-modal modal-flex modal-transparent booking-confirmed-modal"
		v-bind:class="{
			'modal-show': orderRefQueryParameterLoaded && booking.message,
		}"
	>
		<div class="modal-body modal-wide bg-primary">
			<a
				@click.prevent="closeModal()"
				href="#"
				class="modal-close link-close-right"
			></a>
			<div class="row">
				<div class="col-xs-10 col-md-4">
					<h1 class="margin-top-xs-0 margin-bottom-xs-1">
						Det gick inte att slutföra din bokning.
					</h1>
				</div>
				<div class="col-xs-12 col-md-8 padding-bottom-md-5">
					<p v-if="booking.message" v-html="booking.message"></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
	computed: {
		...mapState(["orderRefQueryParameterLoaded", "booking"]),
	},
	methods: {
		closeModal() {
			this.$store.state.orderRefQueryParameterLoaded = false;
		},
	},
};
</script>